import React, {useState} from "react";
import {Container, Dropdown, Grid, Header, Image} from "semantic-ui-react";
import {companies, volunteerExperienceData} from "./volunteerExperienceData";
import 'react-vertical-timeline-component/style.min.css';
import {VolunteerTimeline} from "./VolunteerTimeline";

let mapCompanySearchIcon = ({onClick, isShown}) => ([key, value], pos) => {
    const {logo, backgroundColor = 'white', top, companyName} = value
    return <button
        key={companyName}
        onClick={() => onClick(key)}
        style={{backgroundColor,
}}
        className={'vertical-timeline-element-icon-button-list'}
    >
        <Image src={logo} style={{marginTop: `${top}-1px`, opacity: isShown(key) ? 1 : 0.2}} size='tiny'/>
    </button>;
};

const VolunteerExperience = () => {
    const [filter, setFilter] = useState(Object.keys(companies))
    const [range, setRange] = useState()

    const shouldShowIcon = (company) => filter.includes(company)
    const onClickCompanyIcon = (company) => {
        const newList = [...filter]
        if (newList.includes(company)) {
            setFilter(newList.filter((companyName) => companyName !== company))
        } else {
            newList.push(company)
            setFilter(newList)
        }
    }


    return <Container>
        <Header as="h2">Theatrical Experience</Header>
        <Container>
        <Grid padded={'vertically'}>
            <Grid.Row>
                <Grid.Column  mobile={16} tablet={16} computer={10}>
                    <Header as={'h3'}>Filter</Header>
                    <div style={{flexWrap: "wrap",
                        flexDirection: "row",
                        display: "flex",
                        gap: '1rem'
                    }}>
                    {
                        Object.entries(companies).map(mapCompanySearchIcon({onClick: onClickCompanyIcon, isShown: shouldShowIcon}))
                    }
                    </div>
                    <Header as={'h4'} style={{marginTop: '1rem', cursor: 'pointer', marginBottom: '1.2rem'}} onClick={() => setFilter(Object.keys(companies))}>Clear filter</Header>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={6}>
                    <Header>Time</Header>
                    <Dropdown clearable fluid options={[
                        {key: 1, text: 'Last 30 Days', value: 30},
                        {key: 2, text: 'Last 365 Days', value: 365},
                        {key: 3, text: 'The Last 5 Years', value: 1825},
                    ]} selection onChange={(e, {value}) => setRange(value)} placeholder={'Filter by time'}/>
                </Grid.Column>
            </Grid.Row>
        </Grid>
        </Container>
        <VolunteerTimeline volunteerExperience={volunteerExperienceData.filter(({ todo }) => !todo)} filter={filter} range={range}/>
    </Container>;
}

export default VolunteerExperience